import { useEffect, useState } from "react";
import DesktopSidebar from "../Home/Sidebars/DesktopSidebar";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { useNavigate } from "react-router-dom";
import methodModel from "../../methods/methods";
import Pagination from "react-js-pagination";
import { useSelector } from "react-redux";
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import FormControl from "../../common/FormControl"
import moment from "moment";
import SelectDropdown from "../../common/SelectDropdown";
import milesModal from "../../models/miles.modal";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import environment from "../../environment";

const JobPosts = () => {
    const navigate = useNavigate()
    const userLong = sessionStorage.getItem("userLong") || user?.coordinates?.coordinates?.[0]
    const userLat = sessionStorage.getItem("userLat") || user?.coordinates?.coordinates?.[1]
    const user = useSelector((state) => state.user)
    const [filters, setFilter] = useState({ page: 1, count: 10, search: "", range: "48280.3", long: userLong, lat: userLat })
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)
    const [seeMore, setSeeMore] = useState({ less: true, index: "" })
    const [isOpen, setIsOpen] = useState(false)
    const [form, setForm] = useState({ description: "", id: "", salary: "" })

    const roleOptions = [
        { id: "host", name: "Entertainer" },
        { id: "venue", name: "Venue" },
        { id: "vendor", name: "Vendor" },
    ]

    useEffect(() => {
        getData()
    }, [])

    const getData = (p = {}) => {
        let filter = { ...filters, ...p, postType: "openOpportunities", status: "active" }
        loader(true)
        ApiClient.get("venue/get-all-venue-post", filter).then((res) => {
            if (res.success) {
                setData(res.data.map((itm) => {
                    itm.id = itm._id
                    return itm
                }))
                setTotal(res.total)
            }
            loader(false)
        })
    }

    const filter = (p = {}) => {
        let f = { page: 1, ...p }
        setFilter({ ...filters, ...f });
        getData({ ...f });
    }
    const clear = () => {
        let f = { search: "", location: "", role: "", range: "48280.3", long: userLong, lat: userLat }
        setFilter({ ...filters, ...f });
        getData({ ...f });
    }
    const handleFilter = (e, key) => {
        setFilter({ ...filters, [key]: e });
        getData({ [key]: e });
    }

    const handlePagination = (e) => {
        setFilter((prev) => ({ ...prev, page: e }))
        getData({ page: e })
    }

    const getApplyPostStatus = (item) => {
        const applyPostData = item?.apply_post_details
        const hostId = user?._id || user?.id
        let value = ""
        applyPostData?.filter((item) => {
            if (item?.addedBy === hostId) {
                value = item?.request_status
            }
        })
        return value
    }

    const handleAppyPost = (postId) => {
        if (getApplyPostStatus()) {
            return
        } else {
            setForm({ description: "", id: postId, salary: "" })
            setIsOpen(true)
        }
    }
    const applyPost = (e) => {
        e.preventDefault()
        const payload = {
            postId: form?.id,
            description: form?.description,
            salary: Number(form?.salary)
        }
        ApiClient.post(`host/post/apply`, payload).then(res => {
            if (res.success) {
                getData()
                setIsOpen(false)
            }
        })
    }

    const paymentRequest = (item) => {
        const payload = {
            appliedPostId: item?.apply_post_details?.find((itm) => itm?.addedBy === user?._id)?._id,
            userId: item?.addedFor?._id
        }
        loader(true)
        ApiClient.post("job/payment/request", payload).then(res => {
            if (res.success) {
                getData()
            }
            loader(false)
        })
    }

    const handleLocation = (place) => {
        setFilter({ ...filters, location: place?.formatted_address, lat: place.geometry.location.lat(), long: place.geometry.location.lng() })
    }

    return (
        <>
            <div className="bg-white w-full h-screen">
                <DesktopSidebar />
                <div className="container mx-auto px-5 pb-5">
                    <div className="shadow-box w-[calc(100%_-_0px)] ml-auto bg-white rounded-lg mt-6 border border-[#f1f1f1] shadow-[0px_0px_15px_-12px] p-[1.5rem]">
                        <div className="flex justify-between flex-wrap items-center gap-5 mb-5 pb-5 border-b border-[#f1f1f1]">
                            <div className="">
                                <h3 className="text-2xl font-semibold text-[#134896]">Job Posts</h3>
                            </div>
                            <form className="flex flex-wrap justify-end items-center gap-2" onSubmit={(e) => { e.preventDefault(); filter(); }}>
                                <input
                                    type="text"
                                    id="simple-search"
                                    value={filters?.search}
                                    onChange={(e) => setFilter({ ...filters, search: e.target.value })}
                                    autoComplete="one-time-code"
                                    className="text-gray-900 text-sm rounded-lg focus:border-[#063688] block sm:max-w-[200px] max-[499px]:w-full ps-5 p-2.5 pr-10 border border-[#d1d1d1]"
                                    placeholder="Search..."
                                />
                              
                                    <ReactGoogleAutocomplete
                                        apiKey={environment?.map_api_key}
                                        onPlaceSelected={(place) => { handleLocation(place) }}
                                        onChange={e => setFilter({ ...filters, location: e.target.value })}
                                        value={filters?.location}
                                        options={{
                                            types: ["(regions)"],
                                            componentRestrictions: { country: "us" },
                                        }}
                                        key="eventAddress"
                                        placeholder="Location..."
                                        className="text-gray-900 text-sm rounded-lg focus:border-[#063688]  block sm:max-w-[200px] max-[499px]:w-full  ps-5 p-2.5 pr-10 border border-[#d1d1d1]"
                                    />
                           
                                <div className="max-[499px]:w-full">
                                    <SelectDropdown
                                    className="capitalize "
                                        id="statusDropdown"
                                        displayValue="name"
                                        placeholder="All Roles"
                                        theme="search"
                                        isClearable={false}
                                        intialValue={filters?.role}
                                        result={(e) => { handleFilter(e.value, 'role') }}
                                        options={roleOptions}
                                    />
                                </div>
                                <div className="max-[499px]:w-full                                                                                              ">
                                    <SelectDropdown
                                        id="statusDropdown"
                                        displayValue="name"
                                        placeholder="Select Miles"
                                        theme="search"
                                        isClearable={false}
                                        intialValue={filters?.range}
                                        result={(e) => { handleFilter(e.value, 'range') }}
                                        options={milesModal.list}
                                    />
                                </div>
                                {filters?.search || filters?.location || filters?.role ?
                                    <button type="button" onClick={() => clear()} className="bg-[#063688] leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg">
                                        Clear
                                    </button>
                                    : null}
                                <button type="submit" className="bg-[#063688] leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg">
                                    Search
                                </button>
                            </form>
                        </div>
                        <div className="">
                            {data?.length === 0 ?
                                <div className="text-center py-10">Job Posts Not Found</div>
                                :
                                <div className="grid grid-cols-1">
                                    {data?.map((item, index) => {
                                        return <div className="border-b py-8" key={index}>
                                            <div className="flex flex-wrap justify-between gap-5">
                                                <div>
                                                    <div className="flex items-center gap-3">
                                                        <img src={methodModel.userImg(item?.addedBy?.image)} className="bg-[#D9D9D9] w-[50px] sm:w-[70px] h-[50px] sm:h-[70px] object-cover rounded-full"></img>
                                                        <div className="capitalize">
                                                            <p className="max-[499px]:text-[12px] text-[14px]">{item?.addedBy?.venue_name || item?.addedBy?.fullName}</p>
                                                            <h2 className="max-[499px]:text-[14px] text-[16px] font-[600] leading-[18px]">{item?.title}</h2>
                                                        </div>
                                                    </div>
                                                    <p className="text-[#7b7b7b] flex flex-wrap gap-x-3 mt-3 max-[499px]:!text-[12px] !text-[14px] !font-[500]">
                                                        <span className="">Salary: ${item?.startingSalary || 0} - ${item?.maximumSalary || 0} </span>
                                                    </p>
                                                    {getApplyPostStatus(item) &&
                                                        <div className=" max-[499px]:text-[12px] text-[14px] my-1">Job Post End Date & Time: <span className="text-[#134896]">{moment(item?.apply_post_details?.find((itm) => itm?.addedBy === user?._id)?.jobEndDate).format("DD MMM, YYYY hh:mm A")}</span></div>
                                                    }
                                                </div>
                                                {user?._id !== item?.addedFor?._id &&
                                                    <div className="">
                                                        {getApplyPostStatus(item) ?
                                                            <>
                                                                <div className="flex justify-end gap-2 items-center mt-2 mb-2">
                                                                    <span className="max-[499px]:text-[12px] text-[14px]">Applied Post Status: </span>
                                                                    <div className={`capitalize max-[499px]:text-[12px] text-[14px] h-fit ${getApplyPostStatus(item) === "rejected" ? "text-red-600" : getApplyPostStatus(item) === "accepted" ? "text-green-600" : "text-yellow-600"}`}> {getApplyPostStatus(item)}</div>
                                                                </div>
                                                                {new Date(item?.apply_post_details?.find((itm) => itm?.addedBy === user?._id)?.jobEndDate) < new Date() && item?.apply_post_details?.find((itm) => itm?.addedBy === user?._id)?.jobPostStatus === "working" && item?.apply_post_details?.find((itm) => itm?.addedBy === user?._id)?.pendingAmount !== 0 ?
                                                                    <>
                                                                        {item?.apply_post_details?.find((itm) => itm?.addedBy === user?._id)?.paymentRequestStatus === "pending" ?
                                                                            <button type="button" onClick={e => paymentRequest(item)} className="bg-[#134896] px-5 py-2 text-white max-[499px]:text-[12px] text-[14px] rounded-lg h-fit">Payment Request</button>
                                                                            :
                                                                            <div className="max-[499px]:text-[12px] text-[14px]">Payment Request: <span className="capitalize text-[#134896] max-[499px]:text-[12px] text-[14px] h-fit">{item?.apply_post_details?.find((itm) => itm?.addedBy === user?._id)?.paymentRequestStatus}</span></div>
                                                                        }
                                                                    </>
                                                                    : null
                                                                }
                                                            </>
                                                            :
                                                            <button type="button" onClick={() => handleAppyPost(item?._id || item?.id)} className="bg-[#134896] px-5 py-2 text-white max-[499px]:text-[12px] text-[14px] rounded-lg h-fit">Apply Post</button>
                                                        }
                                                        {item?.apply_post_details?.find((itm) => itm?.addedBy === user?._id)?.jobPostStatus === "completed" &&
                                                            <p className="max-[499px]:text-[12px] text-[14px] w-fit">Job Post: <span className="text-green-600">Completed</span></p>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            <div className="mt-3">
                                                <div className={`text-[14px] ${!seeMore?.less && seeMore?.index === index ? "" : "text_3line w-full"}`} dangerouslySetInnerHTML={{ __html: item?.description }}></div>
                                                {item?.skills?.length > 0 &&
                                                    <p className="flex flex-wrap gap-x-2 mt-3 max-[499px]:!text-[12px] !text-[12px] !font-[500]">
                                                        {item?.skills?.map((itm, i) => {
                                                            return <span className="flex items-center bg-[#f1f1f1] text-[#919191] px-3 py-[2px] rounded-[30px] gap-2" key={i}>{itm?.name}</span>
                                                        })}
                                                    </p>
                                                }
                                                <div onClick={() => { navigate(`/post/detail/${item?._id || item?.id}`) }} className="text-[#134896] max-[499px]:text-[12px] text-[14px] hover:underline cursor-pointer text-right w-fit ml-auto">See More</div>
                                            </div>

                                        </div>
                                    })}
                                </div>
                            }
                        </div>
                        {total > filters?.count ?
                            <div className="pagination_div w-full text-right">
                                <Pagination
                                    activePage={filters?.page}
                                    itemsCountPerPage={filters?.count}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    hideFirstLastPages
                                    prevPageText="Previous"
                                    nextPageText="Next"
                                    itemClass="bg-white px-2 text-[#8f8f8f] rounded-md"
                                    activeClass="!bg-[#005AAB] px-2 !text-white rounded-md"
                                    onChange={e => handlePagination(e)}
                                />
                            </div>
                            : null}
                    </div>
                </div>
            </div>
            <Dialog open={isOpen} as="div" className="relative z-10 focus:outline-none" onClose={() => setIsOpen(true)}>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 bg-[#0000006b]">
                        <DialogPanel transition className="w-full max-w-lg rounded-xl bg-white p-4 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0">
                            <div className="flex justify-between border-b-[1px] border-[#e9e9e9] pb-3 mb-3">
                                <DialogTitle as="h3" className="text-[20px] font-medium text-[#005AAB]">Apply For Post</DialogTitle>
                            </div>
                            <form onSubmit={applyPost}>
                                <div className="my-4 flex flex-wrap justify-center gap-5">
                                    <FormControl
                                        type="number"
                                        name="salary"
                                        label="Salary ($)"
                                        placeholder="Enter Salary ($)"
                                        autoComplete="one-time-code"
                                        value={form?.salary}
                                        onChange={(e) => setForm({ ...form, salary: e })}
                                        maxlength={7}
                                        required
                                    />
                                    <FormControl
                                        type="textarea"
                                        name="description"
                                        label="Description"
                                        placeholder="Enter Description"
                                        autoComplete="one-time-code"
                                        value={form?.description}
                                        onChange={(e) => setForm({ ...form, description: e })}
                                        required
                                    />
                                </div>
                                <div className="flex items-center gap-3 justify-end">
                                    <button type="button" onClick={() => setIsOpen(false)} className="flex items-center justify-center font-semibold rounded-full px-5 py-2 my-3 border border-[#005AAB] text-[#005AAB]">Cancel</button>
                                    <button type="submit" className="flex items-center justify-center font-semibold rounded-full px-5 py-2 my-3 border border-[#005AAB] text-white bg-[#005AAB]">Send</button>
                                </div>
                            </form>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default JobPosts